import React, { useCallback, useState } from "react";
import UserForm from "../UserForm/UserForm";
import { useThunkDispatch } from "store";
import { useHistory, useParams, Redirect } from "react-router-dom";
import { useUserItem } from "store/user/selectors";
import { updateUser } from "store/user/actions";

const DexEdit: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const history = useHistory();
  const params = useParams<{ dexId: string }>();
  const [error, setError] = useState<string | undefined>(undefined);
  const handleErrorClose = useCallback(() => {
    setError(undefined);
  }, []);

  const dex = useUserItem(params.dexId);

  const handleFinish = useCallback(
    async (values) => {
      const action = await thunkDispatch(
        updateUser({
          id: dex?.id,
          ...values,
        })
      );

      if (action.type === updateUser.rejected.toString()) {
        setError(action.payload);
      } else {
        history.goBack();
      }
    },
    [thunkDispatch, history, dex]
  );

  if (!dex) {
    return <Redirect to="/dexs" />;
  }

  return (
    <UserForm
      title="Edit delivery executive"
      subtitle={`Editing ${dex?.name}`}
      onFinish={handleFinish}
      defaultValues={dex}
      okText="Save"
      editing={true}
      error={error}
      onErrorClose={handleErrorClose}
    />
  );
};

export default DexEdit;
